<template>
  <!-- First view on website -- hero full height -->
  <div class="d-flex align-items-center justify-content-center">
    <div id="home-fill" class="d-flex flex-wrap">
      <home-photo />
      <home-logo />
    </div>
    <div id="image" class="position-absolute" role="button" @click="meerInfo_Clicked">
      <peper-logo src="/images/Peper_badge.png" alt="logo" />
    </div>
  </div>
</template>

<script>
// import components
import HomePhoto from '@/components/home/Photo.vue';
import HomeTekst from '@/components/home/Tekst.vue';
import PeperLogo from '@/components/Logo.vue';
import { mapActions } from 'vuex';

// export view
export default {
  name: 'Home',
  components: {
    'home-photo': HomePhoto,
    'home-logo': HomeTekst,
    'peper-logo': PeperLogo,
  },
  methods: {
    ...mapActions({
      updateLocation: 'pageLocation/updateLocation',
    }),

    meerInfo_Clicked() {
      this.$router.push('wiezijnwij');
      this.updateLocation('info');
    },
  },
};
</script>
